module.exports = __webpack_public_path__ + "static/media/formacion-inactive.941b78cb.svg";